import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
  LinkButton,
} from '../../components/typography';
import { Image } from '../../components/Image';
import { Price } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Sælger I blandingsgas?</Heading1>
                  <hr />
                  <Paragraph>
                    <Bold>Svar:</Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Row>
                      <Col xs={12} md={6}>
                        <Paragraph>
                          Ja, vi sælger blandingsgas.
                        </Paragraph>
                        <Paragraph>
                          Pris: <Price varenr="8941" momsIndication />.<br />
                          Pant: <Price varenr="8941" momsIndication embPrice />
                        </Paragraph>
                      </Col>
                      <Col xs={12} md={6}>
                        <Paragraph>
                          <LinkButton to="/bestil/fadoel-og-anlaeg/kulsyre" title="Blandingsgas" primary>Køb blandingsgas her</LinkButton>
                        </Paragraph>
                      </Col>
                    </Row>
                    <Paragraph textCenter>
                      <Image name="kulsyre.blandingsgas-8liter.png" imageHeight="400px" />
                    </Paragraph>
                  </Div>
                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
